<template>
    <b-modal :active.sync="isModalActive" :width="600" scroll="keep" :can-cancel="canCancel" @close="closeModal">
        <div class="border border-blue-light rounded shadow bg-white p-4">
            <form @submit.prevent="saveInvoiceCost" class="w-full">
                <header class="font-thin uppercase text-blue-light modal-card-head_ mb-4">
                    {{ $t('add_invoice') }}
                </header>
                <div class="modal-card-body_ relative">
                    <div class="flex flex-wrap">
                        <div class="w-1/2 px-2">
                            <b-field :label="$t('quantity') + $t('(sobre coste previsto)')">
                                <b-input 
                                    type="number" 
                                    step=".01" 
                                    v-model="invoiceCost.assignment"
                                    title="quantity" 
                                    required 
                                    name="quantity" 
                                    :placeholder="$t('quantity')" 
                                />
                            </b-field>
                        </div>
                        <div class="w-1/2 px-2">
                            <b-field :label="$t('Coste real a origen')">
                                <b-input 
                                    v-model="invoiceCost.price" 
                                    title="price" 
                                    required 
                                    name="price"
                                    :placeholder="$t('price')" 
                                    type="number" 
                                    step=".01" 
                                />
                            </b-field>
                        </div>
                    </div>
                    <div class="flex flex-wrap mx-4 mb-3 justify-end">
                        <v-button type="submit" class="px-4 mt-3">{{ $t('save') }}</v-button>
                    </div>
                </div>
            </form>
        </div>
    </b-modal>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        projectId: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            isModalActive: false,
            canCancel: ['escape', 'x', 'outside'],
            invoiceCost: {
                assignment: 0,
                price: 0,
                cost_detail_id: 0
            },
            invoiceCostId: null
        };
    },
    methods: {
        show(costDetail, invoiceCost = null) {
            if (invoiceCost) {
                this.invoiceCost = {
                    assignment: String(invoiceCost.assignment) || '0',
                    price: Number(invoiceCost.price) || 0,
                    cost_detail_id: costDetail.id
                };
                this.invoiceCostId = invoiceCost.id || null;
            } else {
                this.invoiceCost = {
                    assignment: '0',
                    price: 0,
                    cost_detail_id: costDetail.id
                };
                this.invoiceCostId = null;
            }
            this.isModalActive = true;
        },

        closeModal() {
            this.isModalActive = false;
        },

        async saveInvoiceCost() {
            try {
                const data = {
                    assignment: this.invoiceCost.assignment,
                    price: this.invoiceCost.price,
                    cost_detail_id: this.invoiceCost.cost_detail_id,
                    project_id: this.projectId
                };

                let response;
                if (this.invoiceCostId !== null) {
                    // Actualizar (PUT)
                    response = await axios.put(`/api/v2/invoice-costs/${this.invoiceCostId}`, data);
                } else {
                    // Crear (POST)
                    response = await axios.post('/api/v2/invoice-costs', data);
                }
                if (response.data) {
                    this.$toast.open({
                        message: this.$t('save_successful'),
                        type: 'is-success',
                        position: 'is-top-right'
                    });
                    this.$emit('reload-list');
                    this.closeModal();
                } else {
                    this.$toast.open({
                        message: this.$t('save_error'),
                        type: 'is-danger',
                        position: 'is-top-right'
                    });
                }
            } catch (error) {
                this.$toast.open({
                    message: this.$t('error_saving_invoice'),
                    type: 'is-danger',
                    position: 'is-top-right'
                });
                console.error('Error saving cost invoice:', error);
            }
        }
    }
};
</script>
